module.exports = __webpack_public_path__ + "img/sign-in.8b69a118.png";